import $ from "jquery";
import { Klass, u_, csl } from "@pressmedia/webappbase";
import vuwer from "@pressmedia/vuwer";
import "@pressmedia/vuwform";

/**
 * VuwParamSet (extends VuwerComponent)
 * @options
 * - {String} requiredText
 */
vuwer.appendKlass("VuwParamSet", {
	requiredText: "",
	_rejectOptionsForField: ["name", "inpType", "inpSize"],
	
	_initialize(opt) {
		if( u_.isObject(opt) && u_.isObject(opt.paramInfo) ) {
			if( Klass("VuwParamSet").parent._initialize.call(this, opt) ) {
				// [add VuwField]
				opt = {
					vuwType: `${this.paramInfo.inpType}Field`,
					paramKey: this.name,
					...this.paramInfo
				};
				
				this._rejectOptionsForField.forEach(k => {
					if( u_.hasProperty(opt, k) ) {
						delete opt[k];
					}
				});
				
				if( this.add("field", opt) === false ) {
					csl.warn(`${this.name}._initialize() ... an error occurred.`);
				}
				
				return this;
			}
			return false;
			
		} else {
			csl.warn.red("VuwParamSet._initialize() ... no paramInfo.", opt);
			return false;
		}
	},
	
	setVal(...args) {
		const vuwField = this.get("field");
		return vuwField.setVal(...args);
	},
	
	getVal() {
		return this.get("field").getVal();
	},
	
	clearVal() {
		return this.get("field").clearVal();
	},
	
	getForm() {
		return Klass("VuwField").prototype.getForm.call(this);
	},
	
	render($elm, state) {
		if(u_.isObject(state.gridLeft) || state.rendering) {
			const pi = this.paramInfo;
			
			// **** param name *****
			const $pn = $("<div/>").addClass("pn").append(
				$("<span/>").html( $.parseHTML(pi.name) )
			);
			
			if(pi.required) {
				// 必須項目の場合
				let requiredText = this.requiredText;
				if(!requiredText) {
					const form = this.getForm();
					if(form && form.config.requiredText) {
						requiredText = form.config.requiredText;
					}
				}
				
				$pn.append(
					$("<span/>").addClass("required").html( $.parseHTML(requiredText) )
				);
			}
			
			// データ数制限のある場合
			!!pi.ltd && $pn.append(
				$("<span/>").addClass("limit").attr({
					"data-limit": pi.ltd
				}).text(this.ltdText || "")
			);
			
			if( pi.inpType === "file" && u_.isString(pi.dataType) ) {
				// file項目の場合
				const form = this.getForm();
				if( form && u_.isObject(form.config.maxFileSize) ) {
					$pn.children(".limit").attr(
						"data-size",
						u_.fileSizeToString(form.config.maxFileSize[pi.dataType])
					);
				}
			}
			
			// **** param data ****
			const $pd = $("<div/>").addClass("pd");
			const vuwField = this.get("field");
			
			vuwField.$self = $("<var/>").appendTo($pd);
			vuwField.renderField();
			
			if(state.rendering) {
				// [sub param]
				const className = `vuw-paramset sub-param param-${this.name}`;
				$elm = $("<div/>").addClass(className).attr({
					"data-type": pi.inpType
				});
				
				!!pi.dataType && $elm.attr("data-sub-type", pi.dataType);
				
				(pi.inpType === "period") && $elm.attr({
					"data-hastime": !!pi.hasTime ? "1" : "0"
				});
				
				delete state.rendering;
				
			} else {
				// [main param]
				!pi.inpSize && (pi.inpSize = "f");
				const className = `vuw-paramset param-${this.name} size-${pi.inpSize}`;
				$elm = $("<li/>").addClass(className).attr({
					"data-type": pi.inpType,
					"data-gridSpLeft": !state.gridLeft.sp ? 0 : 1,
					"data-gridPcLeft": !state.gridLeft.pc ? 0 : 1
				});
				
				!!pi.dataType && $elm.attr("data-sub-type", pi.dataType);
				
				(pi.inpType === "period") && $elm.attr({
					"data-hastime": !!pi.hasTime ? "1" : "0"
				});
				
				this.gridLeft = state.gridLeft;
				delete state.gridLeft;
			}
			
			this.getChildren().forEach(vuw => {
				if( vuw instanceof Klass("VuwParamSet") ) {
					$elm.addClass("has-sub-param");
					vuw.$self = $("<var/>").appendTo($pd);
					vuw.setState("rendering", true);
				}
			});
			
			return $elm.append($pn, $pd);
		}
	}
}, "VuwerComponent");
